import React, { useEffect, useState } from 'react';
export function CountdownBanner() {
  const [seconds, setSeconds] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = sessionStorage.getItem('countdown_end');
      if (stored) {
        const remaining = Math.floor((parseInt(stored, 10) - Date.now()) / 1000);
        return remaining > 0 ? remaining : 0;
      }
      const end = Date.now() + 15 * 60 * 1000;
      sessionStorage.setItem('countdown_end', String(end));
    }
    return 15 * 60;
  });
  useEffect(() => {
    if (seconds <= 0) return;
    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = String(Math.floor(seconds / 60)).padStart(2, '0');
  const secs = String(seconds % 60).padStart(2, '0');
  return <div className="w-full max-w-xl mx-auto mt-8" data-id="element-68">
      <div className="bg-[#1a1a1a] border border-[#FF6B00]/30 rounded-xl p-5 shadow-[0_0_30px_rgba(255,107,0,0.1)] text-center" data-id="element-69">
        <h3 className="text-[#FF6B00] font-bold text-xl uppercase tracking-wide mb-1" data-id="element-70">
          OFERTA <span className="underline decoration-2" data-id="element-71">SOLO POR HOY</span>{' '}
          !!!
        </h3>
        <p className="text-gray-400 text-sm mb-4" data-id="element-72">
          Reserva válida por{' '}
          <span className="text-white font-bold" data-id="element-73">15 minutos.</span>{' '}
          <br className="md:hidden" data-id="element-74" />
          Si no accedés, tu descuento pasa a la siguiente persona.
        </p>

        <div className="flex items-center justify-center gap-4 mb-4" data-id="element-75">
          <div className="flex flex-col items-center" data-id="element-76">
            <span className="text-5xl font-black text-[#FF6B00] drop-shadow-[0_0_10px_rgba(255,107,0,0.3)]" style={{
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-77">
              {mins}
            </span>
            <span className="text-gray-500 text-xs uppercase tracking-wider mt-1" data-id="element-78">
              Minutos
            </span>
          </div>
          <span className="text-3xl font-black text-[#FF6B00] -mt-5" data-id="element-79">:</span>
          <div className="flex flex-col items-center" data-id="element-80">
            <span className="text-5xl font-black text-[#FF6B00] drop-shadow-[0_0_10px_rgba(255,107,0,0.3)]" style={{
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-81">
              {secs}
            </span>
            <span className="text-gray-500 text-xs uppercase tracking-wider mt-1" data-id="element-82">
              Segundos
            </span>
          </div>
        </div>

        {/* Payment Trust Logos */}
      </div>
    </div>;
}